import { FormSubmit } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorCourses/CoursesManagement";
import { FormStatus } from "~/shared/lib/statuses";

export const toServer = (data: FormSubmit) => {
  const {
    name,
    code,
    codeIS,
    certificateValidityPeriod,
    status,
    level,
    replacementCourseIds,
  } = data;

  return {
    name,
    code,
    codeIS: codeIS,
    certificateValidityPeriod: certificateValidityPeriod,
    status: FormStatus[status.value],
    levelId: level?.value != null ? Number(level.value) : undefined,
    replacementCourseIds:
      replacementCourseIds && replacementCourseIds.length > 0
        ? replacementCourseIds
            .map((item) => item.value)
            .filter((value): value is number => value != null)
            .map(Number)
        : [],
  };
};
